import { makeStylesheetLink } from "@self/stylesheet";

export class CouponCheckbox extends HTMLElement {

	shadow: ShadowRoot;
	input: HTMLInputElement;
	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.input = <input type="checkbox" name="discountCode" /> as HTMLInputElement;

		this.onClick = onClick.bind(this);

		this.shadow.append(
			<label className="gct-custom-checkbox">
				{this.input}
				<span>I have a discount code</span>
			</label>,
			makeStylesheetLink(),
		);
	}

	connectedCallback() {
		this.input.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.input.removeEventListener("click", this.onClick);
	}
}

function onClick(this: CouponCheckbox) {
	const applyCoupon = document.getElementById("coupon-code");
	if (applyCoupon) {
		if (this.input.checked) {
			applyCoupon.style.display = "block";
			applyCoupon.style.paddingTop = "16px";
		} else {
			applyCoupon.style.display = "none";
		}
	}
}
